module.exports = __webpack_public_path__ + "static/media/Authentic_gaming.75c5be66.png";